/**
 * O rodapé do template: marca à esquerda, quatro colunas de links à direita,
 * barra de direitos embaixo e o halo que sobe do fundo.
 *
 * O formulário de newsletter do original não veio. Ele é um `<form method="get">`
 * que o Webflow liga ao painel dele; aqui não há lista de e-mails, e um campo
 * que aceita o endereço da pessoa e não escreve em lugar nenhum é pior do que
 * campo nenhum — quem se cadastra fica esperando um contato que nunca sai. No
 * lugar dele entrou o convite para o canal onde a organização de fato avisa das
 * edições. Quando existir uma lista de verdade, o formulário volta: o estilo
 * dele já está portado em `template.css`.
 */

import { Link } from 'react-router';
import { NomeDaMarca } from '@/components/LogoMPC';

const COLUNAS = [
  {
    titulo: 'Competição',
    links: [
      { to: '/campeonatos', rotulo: 'Campeonatos' },
      { to: '/estatisticas', rotulo: 'Estatísticas' },
      { to: '/regulamento', rotulo: 'Regulamento' },
    ],
  },
  {
    titulo: 'Comunidade',
    links: [
      { to: '/times', rotulo: 'Times' },
      { to: '/cadastrar-time', rotulo: 'Inscrever meu time' },
      { to: '/entrar', rotulo: 'Área do capitão' },
    ],
  },
  {
    titulo: 'Suporte',
    links: [
      { to: '/suporte', rotulo: 'Abrir um ticket' },
      { to: '/regulamento#punicoes', rotulo: 'Punições e recursos' },
    ],
  },
] as const;

export function RodapeTemplate() {
  return (
    <section className="footer">
      <div className="container">
        <div className="footer-wrapper">
          <div className="footer-left-content">
            <Link to="/" className="navbar-brand footer" aria-label="MPC — página inicial">
              <img src="/logo.webp" alt="" aria-hidden draggable={false} className="nav-logo" />
              <NomeDaMarca tamanho="lg" />
            </Link>

            <p className="large-paragraph">
              Competição de Pro Clubs do EA SPORTS FC: sorteio auditável, tabela sempre em dia e
              estatísticas oficiais. PS5, Xbox Series X|S e PC.
            </p>
          </div>

          <div className="footer-right-content">
            {COLUNAS.map((coluna) => (
              <nav key={coluna.titulo} className="footer-content" aria-label={coluna.titulo}>
                <div className="page-title">{coluna.titulo}</div>
                <div className="footer-pages-link">
                  {coluna.links.map((link) => (
                    <Link key={link.rotulo} to={link.to} className="page-link">
                      {link.rotulo}
                    </Link>
                  ))}
                </div>
              </nav>
            ))}
          </div>
        </div>
      </div>

      <div className="copyright-block">
        <div className="container">
          <div className="copyright-wrapper">
            <div className="copyright-text">
              © {new Date().getFullYear()} MD Pro Clubs Championship.
            </div>
            <div className="copyright-text">
              Não afiliado à Electronic Arts. EA SPORTS FC é marca registrada da Electronic Arts
              Inc.
            </div>
          </div>
        </div>
      </div>

      {/* O halo verde que sobe do rodapé. No template é uma imagem de 2880px;
          aqui é um gradiente, que custa zero byte e acompanha o tema. */}
      <div className="footer-gradient" aria-hidden />
    </section>
  );
}
